import { render, staticRenderFns } from "./my_trusteeshio2.vue?vue&type=template&id=64771250&scoped=true&"
import script from "./my_trusteeshio2.vue?vue&type=script&lang=js&"
export * from "./my_trusteeshio2.vue?vue&type=script&lang=js&"
import style0 from "./my_trusteeshio2.vue?vue&type=style&index=0&id=64771250&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64771250",
  null
  
)

export default component.exports